import {
  Autocomplete,
  Box,
  Button,
  CardContent,
  Paper,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getAreasPublic } from "../../services/AreaService";
import { login, changePassword } from "../../services/AuthService";
import { systemCode, systemName } from "../../configs/config";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import backgroundImage from "../../../assets/background-image.png";
import { limpiaLocalStorage } from '../../../project/utils/utils';
import AuthContext from "../../contexts/AuthContext";

const initialState = {
  idUsuario: "",
  userName: "",
  password: "",
  newPassword: "",
  newPasswordConfirmacion: "",
};
//
// #############################################################################
//
const LoginComponent = () => {
  const navigate = useNavigate();
  const [idArea, setIdArea] = useState("");
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPasswordConfirmacion, setShowNewPasswordConfirmacion] = useState(false);
  const [userData, setUserData] = useState(initialState);
  const [areaSelected, setAreaSelected] = useState({
    id_area: "",
    descripcion_area: "",
  });
  const [valueACAreas, setValueACAreas] = useState(null);
  const [inputValueACAreas, setInputValueACAreas] = useState("");
  const [areas, setAreas] = useState([]);
  const [mustChangePasswordTmp, setMustChangePasswordTmp] = useState(false);
  const { setAuth } = useContext(AuthContext);
  //
  // #############################################################################
  //
  useEffect(() => {

    limpiaLocalStorage();

    localStorage.setItem("codigo_sistema", systemCode);

    if (!localStorage.getItem("id_area_deposito")) {
      loadAreas();
    }
  }, []);
  //
  // ################################################################################
  //
  const loadAreas = async () => {

    let _params = {
      actividad: "produccion",
    };

    setIsDoingSomething(true);
    const response = await getAreasPublic(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      let _areas = [];
      _response.forEach((item) => {
        _areas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setAreas(_areas);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // #############################################################################
  //
  const handleLogin = () => {

    if (!localStorage.getItem("id_area_deposito")) {
      if (!valueACAreas) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Área",
        });
        setShowMessage(true);
        return;
      }
    }

    if (userData.userName === "" || userData.password === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el usuario y la contraseña",
      });
      setShowMessage(true);
      return;
    }

    loginUser();
  };
  //
  // #############################################################################
  //
  const loginUser = async () => {

    const _params = {
      codigo_sistema: localStorage.getItem("codigo_sistema"),
      id_area: !localStorage.getItem("id_area_deposito") ? valueACAreas.id : localStorage.getItem("id_area_deposito"),
      username: userData.userName,
      password: userData.password,
    };

    setIsDoingSomething(true);
    const response = await login(_params);
    setIsDoingSomething(false);

    if (response.ok) {

      if (!localStorage.getItem("id_area_deposito")) {
        localStorage.setItem("id_area_deposito", valueACAreas.id);
        localStorage.setItem("descripcion_area_deposito", valueACAreas.label);
      }

      const _response = response.data.data[0];

      if (_response.change_password) {
        // si el usuario debe cambiar su contraseña temporal, se muestra el formulario de cambio de contraseña

        setMustChangePasswordTmp(true);
        setUserData({
          ...userData,
          idUsuario: _response.id_usuario,
        });
      } else {
        // si el usuario no debe cambiar su contraseña temporal, se inicia sesión normalmente

        const _token = _response.access_token;
        const _decodedToken = jwtDecode(_token);

        setAuth({
          roles: _decodedToken.roles,
          permisos: _decodedToken.permissions,
          token: _token,
          user: _decodedToken.user,
        });

        localStorage.setItem("token", _token);
        localStorage.setItem("token_exp", _decodedToken.exp);
        localStorage.setItem("nombre_usuario", _decodedToken.user.nombre);
        localStorage.setItem("apellido_usuario", _decodedToken.user.apellido);
        localStorage.setItem("id_usuario", _decodedToken.user.id_usuario);
        navigate("/inicio");
      }
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // #############################################################################
  //
  const handleChangePasswordTmp = async () => {

    if (userData.newPassword === "" || userData.newPasswordConfirmacion === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar la nueva contraseña y confirmarla",
      });
      setShowMessage(true);
      return;
    }

    if (userData.newPassword === userData.password) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña no puede ser igual a la actual",
      });
      setShowMessage(true);
      return;
    }

    if (userData.newPassword !== userData.newPasswordConfirmacion) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña y su confirmación no coinciden",
      });
      setShowMessage(true);
      return;
    }

    if (userData.newPassword === userData.userName) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña no puede ser igual a tu nombre de usuario",
      });
      setShowMessage(true);
      return;
    }

    if (userData.newPassword.includes(" ")) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña no debe contener espacios",
      });
      setShowMessage(true);
      return;
    }

    if (userData.newPassword.length < 6 || userData.newPassword.length > 20) {
      setMessage({
        severity: "error",
        messageText: "La nueva contraseña debe tener entre 6 y 20 caracteres",
      });
      setShowMessage(true);
      return;
    }

    changePasswordTmp();
  }
  //
  // #############################################################################
  //
  const changePasswordTmp = async () => {

    const _params = {
      id: userData.idUsuario,
      password_actual: userData.password,
      password_nuevo: userData.newPassword,
      password_confirmacion: userData.newPasswordConfirmacion,
    };

    setIsDoingSomething(true);
    const response = await changePassword(_params);
    setIsDoingSomething(false);

    if (response.ok) {

      setMustChangePasswordTmp(false);
      setUserData({
        ...userData,
        password: "",
        newPassword: "",
        newPasswordConfirmacion: "",
      });

      setMessage({
        severity: "success",
        messageText: "Contraseña cambiada correctamente, por favor inicia sesión",
      });
      setShowMessage(true);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // #############################################################################
  //
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (!mustChangePasswordTmp) {
        handleLogin();
      } else {
        handleChangePasswordTmp();
      }
    }
  };
  //
  // #############################################################################
  //
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Typography variant="h4" gutterBottom sx={{
          color: "#fff",
          fontWeight: "bold",
          textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8)",
          mb: 2,
          mt: 1,
        }}>
          {systemName}
        </Typography>

        <Paper
          elevation={3}
          sx={{ width: "100%", maxWidth: 400, p: 2, textAlign: "center" }}
        >

          {localStorage.getItem("id_area_deposito") && (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", m: 3 }}>
              <Typography variant="subtitle1">{localStorage.getItem("descripcion_area_deposito")}</Typography>
            </Box>
          )}

          {!mustChangePasswordTmp && (
            <>
              {!localStorage.getItem("id_area_deposito") && (
                <Grid item xs={12} md={6} lg={4}>
                  <Autocomplete
                    id="area"
                    sx={{ width: "100%", mb: 3 }}
                    size="small"
                    name="areas"
                    fullWidth
                    value={valueACAreas ?? null}
                    onChange={(event, newValue) => {
                      setValueACAreas(newValue);
                    }}
                    inputValue={inputValueACAreas}
                    onInputChange={(event, newInputValue) => {
                      setInputValueACAreas(newInputValue);
                    }}
                    options={areas}
                    renderInput={(params) => <TextField {...params} label="Área" />}
                    isOptionEqualToValue={(option, value) => {
                      if (!value || !value.id) return false;
                      return option.id === value.id;
                    }}
                    getOptionLabel={(option) => option.label || ""}
                  />
                </Grid>
              )}

              <Box sx={{ mt: 3 }}>
                <TextField
                  id="userName"
                  label="Usuario"
                  name="userName"
                  variant="outlined"
                  value={userData.userName}
                  size="small"
                  autoFocus
                  required
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  fullWidth
                  sx={{ mb: 3 }}
                />

                <TextField
                  id="password"
                  label="Contraseña"
                  variant="outlined"
                  name="password"
                  value={userData.password}
                  required
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  type={showPassword ? "text" : "password"}
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleLogin}
                  sx={{ color: "#fff" }}
                >
                  Iniciar sesión
                </Button>
              </Box>
            </>
          )}

          {mustChangePasswordTmp && (
            <>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", m: 3 }}>
                <Typography variant="subtitle1">
                  Tu contraseña actual es temporal
                </Typography>
                <Typography variant="subtitle1">
                  Por favor cambiala para continuar
                </Typography>
              </Box>

              <Box sx={{ mt: 3 }}>
                <TextField
                  id="newPassword"
                  label="Nueva contraseña"
                  variant="outlined"
                  name="newPassword"
                  value={userData.newPassword}
                  required
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  type={showNewPassword ? "text" : "password"}
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          edge="end"
                          size="small"
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="newPasswordConfirmacion"
                  label="Confirma nueva contraseña"
                  variant="outlined"
                  name="newPasswordConfirmacion"
                  value={userData.newPasswordConfirmacion}
                  required
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  type={showNewPasswordConfirmacion ? "text" : "password"}
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowNewPasswordConfirmacion(!showNewPasswordConfirmacion)}
                          edge="end"
                          size="small"
                        >
                          {showNewPasswordConfirmacion ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleChangePasswordTmp}
                  sx={{ color: "#fff" }}
                >
                  Cambiar contraseña
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </CardContent>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </Box>
  );
};
export default LoginComponent;